import { useRef, useEffect } from 'react'
import anime from 'animejs'
import { Box } from '@chakra-ui/react'

import { ReactComponent as Image } from '@/svg/services/accept-terms-rafiki.svg'

interface Props {
  animate?: boolean
}

function CookiesImage({ animate = true }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && animate) {
      const animInstances: anime.AnimeInstance[] = []

      // const containerClassName = containerRef.current.className
      //   .split(' ')
      //   .join('.')

      // const animateConfig = {
      //   easing: 'easeInOutSine',
      //   loop: true,
      //   duration: 1000,
      //   delay: 350,
      //   endDelay: 350,
      // }

      // animInstances.push(
      //   anime({
      //     ...animateConfig,
      //     targets: `.${containerClassName} #pen-trace`,
      //     strokeDashoffset: [anime.setDashoffset, 0],
      //   }),
      // )

      return () =>
        animInstances.forEach((instance: anime.AnimeInstance) =>
          instance.pause(),
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [containerRef.current, animate])

  return (
    <Box ref={containerRef}>
      <Image />
    </Box>
  )
}
export default CookiesImage
